/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DtoVehicleBaseResponse as ModelsV4VehicleDtoVehicleBaseResponse } from '../../models/Models/v4/Vehicle/dto-vehicle-base-response';

export interface V4ApplicationsApplicationIdVehicleGet$Json$Params {
  applicationId: string;
  StockNo: number;
  DealerCode?: string;
}

export function v4ApplicationsApplicationIdVehicleGet$Json(http: HttpClient, rootUrl: string, params: V4ApplicationsApplicationIdVehicleGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4VehicleDtoVehicleBaseResponse>> {
  const rb = new RequestBuilder(rootUrl, v4ApplicationsApplicationIdVehicleGet$Json.PATH, 'get');
  if (params) {
    rb.path('applicationId', params.applicationId, {});
    rb.query('StockNo', params.StockNo, {});
    rb.query('DealerCode', params.DealerCode, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsV4VehicleDtoVehicleBaseResponse>;
    })
  );
}

v4ApplicationsApplicationIdVehicleGet$Json.PATH = '/v4/applications/{applicationId}/vehicle';
